

export default class Cell {

  constructor(){
    this.posX = new Array(4);
    this.posY = new Array(4);
  }
}
